<template>
  <div name="demo-logical-statement">
    {{statement.code}}
    {{statement.description}}
    <hrms-logical-statement :listFields="listFields"
                            :nowLang="nowLang"
                            v-model="statement" />
  </div>
</template>

<script>
  export default {
    name: 'demo-logical-statement',
    data () {
      return {
        lists: [],
        statement: {
          code: '',
          description: ''
        },
        nowLang: 'th',
        listFields: {
          en: [
            { code: 'codempid', description: 'Employee Code', type: 'varchar2' },
            { code: 'numlvl', description: 'Number Level', type: 'number' },
            { code: 'codpos', description: 'Position Code', type: 'varchar2' },
            { code: 'dtestrt', description: 'Start Date', type: 'date' }
          ],
          th: [
            { code: 'codempid', description: 'รหัสพนักงาน', type: 'varchar2' },
            { code: 'numlvl', description: 'ระดับ', type: 'number' },
            { code: 'codpos', description: 'รหัสตำแหน่ง', type: 'varchar2' },
            { code: 'dtestrt', description: 'วันที่เริ่มต้น', type: 'date' }
          ]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// demoLogicalStatement.vue?1c57a38f